import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AgrChartModule } from '@next/core-lib/chart';

import { FlockMultilineChartComponent } from './flock-multiline-chart.component';

@NgModule({
  declarations: [FlockMultilineChartComponent],
  exports: [FlockMultilineChartComponent],
  imports: [CommonModule, AgrChartModule],
  providers: [],
})
export class FlockMultilineChartModule {}
